"use client";

import { atom, useAtom } from "jotai";
import { useModal } from "~/lib/hooks/useModal";

const searchModeAtom = atom<"searched" | "default">("default");

export const useAlgoliaSearchModal = () => {
	const [mode, setMode] = useAtom(searchModeAtom);
	const { isOpen, openModal, closeModal, toggleModal } = useModal(
		"searchBar",
		() => {
			// Reset mode when closing modal
			setMode("default");
		},
		true,
	);

	return {
		isOpen,
		openModal,
		closeModal,
		toggleModal,
		mode,
		setMode,
	};
};
